<script lang='ts'>
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';
  export let storefront : Storefront;
  export let callbacks: any;

  function update() {
    callbacks.update(storefront);
    callbacks.pullCatalog();
  }

  const catalogSortByOptions = [
    {label: 'Most Popular By Market', value: 'most_popular'},
    {label: 'Most Popular By Distributor', value: 'most_popular_by_distributor'}
  ];

  const catalogItemsPerPageOptions = [
    {label: '16', value: '16'},
    {label: '20', value: '20'},
    {label: '24', value: '24'},
    {label: '30', value: '30'},
  ];

</script>

{#if storefront.enable_catalog}
<section class="fizz-text-small">
  <label class="fizz-label fizz-stack-8" for="catalog_sort_by">Sort By {#if !storefront.distributor.uses_distribution_areas}(coming soon){/if}</label>
  <select class="fizz-select fizz-stack-16"
    name="catalog_sort_by" id='catalog_sort_by'
    bind:value={storefront.catalog_sort_by}
    on:change={update}
    disabled={!storefront.distributor.uses_distribution_areas}
  >
    {#each catalogSortByOptions as catalogSortBy }
      <option value={catalogSortBy.value}>{catalogSortBy.label}</option>
    {/each}
  </select>
  <label class="fizz-label fizz-stack-8" for="catalog_items_per_page">Items Per Page</label>
  <select class='fizz-select'
    name="catalog_items_per_page" id='catalog_items_per_page'
    bind:value={storefront.catalog_items_per_page}
    on:change={update}
  >
    {#each catalogItemsPerPageOptions as catalogItemsPerPage }
      <option value={catalogItemsPerPage.value}>{catalogItemsPerPage.label}</option>
    {/each}
  </select>
</section>
{/if}